import { render } from "./InputTextArea.vue?vue&type=template&id=0a0a4502"
import script from "./InputTextArea.vue?vue&type=script&lang=js"
export * from "./InputTextArea.vue?vue&type=script&lang=js"

import "./InputTextArea.vue?vue&type=style&index=0&id=0a0a4502&lang=scss"
script.render = render

export default script